module.exports = __webpack_public_path__ + "static/media/T_Rosalia_Fernandez_San_Agustin.2a6d742d.png";